import styles from './FullScreenLoading.module.scss';

const FullScreenLoading = () => {
  return (
    <div className={styles['full-screen-loading']}>
      <div className={styles['loader-container']}></div>
    </div>
  );
};

export default FullScreenLoading;
